// extracted by mini-css-extract-plugin
module.exports = {"Toolbar":"Toolbar_Toolbar__1OMwe","DeskopOnly":"Toolbar_DeskopOnly__1zq0L"};